/* VF sections - shared behaviour (add to cart triggers, read more, video slider) */
(function () {
  if (window.__vfSectionsInit) return;
  window.__vfSectionsInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vf-atc]');
    if (!btn) return;
    e.preventDefault();
    var target = document.querySelector(
      'form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] [type="submit"][name="add"]'
    );
    if (target) {
      target.scrollIntoView({ block: 'center', behavior: 'smooth' });
      setTimeout(function () { target.click(); }, 400);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vf-more]');
    if (!btn) return;
    var card = btn.closest('[data-vf-card]');
    if (!card) return;
    var open = card.classList.toggle('is-open');
    btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
  });

  document.addEventListener('click', function (e) {
    var item = e.target.closest('[data-vf-video]');
    if (!item) return;
    var video = item.querySelector('video');
    if (!video) return;
    video.muted = !video.muted;
    item.classList.toggle('is-unmuted', !video.muted);
    if (video.paused) video.play();
  });

  function observeVideos() {
    var videos = document.querySelectorAll('[data-vf-video] video');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.4 });
    videos.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState !== 'loading') observeVideos();
  else document.addEventListener('DOMContentLoaded', observeVideos);
  document.addEventListener('shopify:section:load', observeVideos);
})();
